import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';

import { IWidgetManifest } from '../../../ServicePickerWidget/types/widgetManifest';
import { useAppContext } from '../../../AppModulesWrapper';

export const PaymentWidgetMicrofrontend = () => {
  const { config, logger } = useAppContext();

  const manifest = config.get<IWidgetManifest>('paymentWidgetManifest');

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Модалки пополнения баланса', {
      domain: 'microfrontends.payment-widget.manifest',
    });

    return null;
  }

  return <Microfrontend {...manifest} />;
};
